<template>
    <div class="consent-banner" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="banner-content">
            <!-- prettier-ignore -->
            <div class="text-box">
                {{ $t("cookie_consent.cookies_infotext_before") }}&nbsp;<span class="config-link" @click="openConfig">{{ $t("cookie_consent.cookies_configure_here") }}</span>{{ $t("cookie_consent.cookies_infotext_after") }}&nbsp;{{ $t("cookie_consent.cookies_more_info_before")}}&nbsp;<span class="config-link" @click="openPrivacypolicy">{{$t("cookie_consent.cookies_more_info_here")}}</span>&nbsp;{{$t("cookie_consent.cookies_more_info_after")}}
            </div>
            <div class="button-box">
                <button class="button-cta" @click="sendChoice({ statistics: true, other: true })">
                    {{ $t("cookie_consent.cookies_accept") }}
                </button>
                <button class="button-as-link" @click="sendChoice({ statistics: false, other: false })">
                    {{ $t("cookie_consent.cookies_decline") }}
                </button>
                <button class="button-as-link" @click="openConfig">
                    {{ $t("cookie_consent.cookies_configure_link") }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    inject: ["openConfig", "openPrivacypolicy"],
    methods: {
        sendChoice(values) {
            console.log("save Choice aus Banner", { statistics: values.statistics, other: values.other });
            this.$emit("save-choice", { statistics: values.statistics, other: values.other });
        },
        openPrivacypolicy() {
            console.log('### origin: "' + window.location.origin + '"');
            console.log('### host: "' + window.location.host + '"');
            console.log('### pathname: "' + window.location.pathname + '"');

            let privacyLink;
            const language = window.location.pathname.substring(1,3);
            switch (language) {
                case "de":
                    privacyLink = "https://www.interhome.group/de-de/datenschutz-richtlinien";
                    break;
                case "en":
                    privacyLink = "https://www.interhome.group/en-gb/privacy-policy";
                    break;
                case "fr":
                    privacyLink = "https://www.interhome.group/fr-fr/protection-des-donnees";
                    break;
                case "it":
                    privacyLink = "https://www.interhome.group/it-it/privacy-policy";
                    break;
                case "hr":
                    privacyLink = "https://www.interhome.group/hr-hr/politika-privatnosti";
                    break;
                case "nl":
                    privacyLink = "https://www.interhome.group/nl-nl/privacy-beleid";
                    break;
                case "pl":
                    privacyLink = "https://www.interhome.group/pl-pl/polityka-prywatnosci";
                    break;
                case "pt":
                    privacyLink = "https://www.interhome.group/pt-pt/politica-de-privacidade";
                    break;
                case "es":
                    privacyLink = "https://www.interhome.group/es-es/politica-de-privacidad";
                    break;
                case "cs":
                    privacyLink = "https://www.interhome.group/cs-cz/zasady-ochrany-osobnich-udaju";
                    break;
                default:
                    privacyLink = "https://www.interhome.group/en-gb/privacy-policy";
            }
            window.location.href = privacyLink;
        }
    }
};
</script>

<style scoped>
.consent-banner {
    position: fixed;
    width: 100%;
    bottom: 0px;
    background-color: #f2f2f2;
    box-shadow: 0 0 2em rgba(0, 0, 0, 0.4), 0 1px 4px rgba(0, 0, 0, 0.3);
    outline: none;
}
.banner-content {
    /* max-width: 480px; */
    margin: 0 auto;
    padding: 0.875rem 0.875rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}
@media screen and (min-width: 768px) {
    .banner-content {
        max-width: 1200px;
        padding: 1.5rem 1.25rem;
        flex-direction: row;
        justify-content: space-around;
        /* align-items: center; */
    }
}

.text-box {
    flex: 1 1 auto;
    text-align: justify;
    font-size: 0.875rem;
}

@media screen and (min-width: 768px) {
    .text-box {
        margin-right: 2rem;
        max-width: 720px;
        font-size: 1rem;
    }
}

.config-link {
    display: inline-block;
    cursor: pointer;
    text-decoration: underline;
}

.button-box {
    display: flex;
    flex: 1 1 0%;
    justify-content: normal;
    flex-direction: row-reverse;
    flex-wrap: nowrap;
}

@media (max-width: 479px) {
    .button-box {
        flex-wrap: wrap;
    }
}

@media (min-width: 768px) {
    .button-box {
        flex-direction: column;
        align-items: stretch;
        flex-wrap: nowrap;
    }
}

.button-as-link {
    min-width: 10rem;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
    color: #424242;
    background: none;
    cursor: pointer;
    /* border: none; */
    /* background-color: #d1d5db; */
    border: 1px solid;
    border-color: #f2f2f2;
}
.button-as-link:hover {
    background-color: #d1d5db;
    /* border: 1px solid; */
    border-color: var(--color-primary, #0096db);
    border-radius: 4px;
}
@media (max-width: 479px) {
    .button-as-link {
        margin-right: 0;
    }
}

@media (min-width: 768px) {
    .button-as-link {
        margin-right: 0;
        /* text-decoration: underline; */
    }
}

.button-std,
.button-cta,
.button-as-link {
    margin-top: 0.5rem;
    width: 100%;
}

@media (min-width: 768px) {
    .button-cta {
        margin-top: 0;
    }
}
</style>
